const loginMap = new Map<string, string>([
  // 发送验证码
  ['sendCode', '/sendCode'],
  // 登录
  ['login', '/login'],
  // 登出
  ['logout', '/logout'],
  // 忘记密码
  ['forgetPassword', '/account/forgetPassword']
]);


import { get, post } from '@/common/request';


export function login(params: any) {
  return post('/login', params, { proxyApi: '/mirage', needHint: true });
}

export function logout() {
  return get('/logout', {}, { proxyApi: '/mirage', needHint: true });
}



export default loginMap;
